import React, {useCallback, useEffect, useMemo, useState} from "react";
import "./App.css";
import {Route, Switch, useHistory} from "react-router-dom";
import Routes from "../routing/Routes";
import {
    CssBaseline,
    ThemeProvider,
    Box,
    Logout,
    darkTheme,
    theme,
    AuthActions,
    AuthGState,
    Footer,
    MainLoader,
    Navbar,
    useFavoriteTheme,
    getAllOrgsIdsForUserByServiceName,
    apiClient,
    AlertTypes,
    setAlert,
} from "@leap4/frontend";

import {useLocation} from "react-router-dom";
import {ConnectedProps, useDispatch} from "react-redux";
import {connect} from "react-redux";
import {
    BACKEND_SERVICE_NAME,
    logoutUrl,
    meMultiUrl,
    publisherLoginsUrl,
    requiredAuthRoles
} from "../../config/generals";
import {RootState} from "../../interfaces/root-state.interface";
import {useQuery} from "react-query";
import {PublisherLoginsSelect} from "../common/PublisherLoginsSelect/PublisherLoginsSelect";
import {IPLData} from "../modules/home/home";
import {SelectedPLContext} from "../../store/context/SelectedPL";
import {PublisherLoginsContext} from "../../store/context/PublisherLogins";
import {queryClient} from "../../index";

const mapStateToProps = (state: RootState) => ({
    auth: state.auth,
    selectedOrganization: state.auth.selectedOrganizationId
});
const mapActions = {
    setAlert
}
const connector = connect(mapStateToProps, mapActions);
type PropsFromRedux = ConnectedProps<typeof connector>;

interface IProps extends PropsFromRedux {
    history: History,
    auth: AuthGState,


}

export const FETCH_PUBLISHER_LOGINS = 'fetch_publisher_logins';
const App = ({auth, selectedOrganization}: IProps) => {

    const history = useHistory();
    const [selectedTheme, setSelectedTheme] = useFavoriteTheme()
    const location = useLocation();
    const dispatch = useDispatch();
    const [bIsSidebarOpen, SetSideBarOpenState] = useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const [selectedPL, setSelectedPL] = useState('');

    const
        fetchPublisherLogins = async (): Promise<IPLData[]> => {
            isLoadingGeneral = true
            const x = ((await apiClient.get(publisherLoginsUrl)).data)
            isLoadingGeneral = false
            return x
        }
    const {
        data: publisherLogins,
        isFetching: isFetchingPL,
        isLoading: isLoadingPL,
        isRefetching: isRefetchingPL,
        refetch: refetchPublisherLogins,


    } = useQuery([FETCH_PUBLISHER_LOGINS, selectedOrganization], fetchPublisherLogins, {
        refetchOnWindowFocus: false,
        onError: (err: Error) => {
            queryClient.setQueryData(FETCH_PUBLISHER_LOGINS, [])
            setAlert({msg: err.message, type: AlertTypes.FAILURE})
        },
        onSuccess: (publisherLogins: IPLData[]) => {
            const firstPL = publisherLogins[0]?.pLId;
            setSelectedPL(firstPL)

        },
        cacheTime: 0,
        enabled: Boolean(auth.user),
        retry: 0,
        initialData: null
    })

    useEffect(() => {
        setSelectedPL('')
    }, [selectedOrganization])
    let isLoadingGeneral = isLoadingPL || isFetchingPL;
    const nSidebarWidth = 240;

    const styles = {
        root: {
            display: "flex",
        },
        toolbar: {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            minHeight: { xs: 110, md: 120 },
        },
        content: {
            flexGrow: 1,
            width: "100%",
            margin: "auto",
        },
    };

    const userOrganizations = useMemo(() => {
        if (!auth.user?.organizations) return [];
        return getAllOrgsIdsForUserByServiceName(auth.user, auth.user.organizations as string[], requiredAuthRoles, BACKEND_SERVICE_NAME);
    }, [auth.user?._id, auth.user?.organizations]);

    const handleThemeChange = (checked) => {
        const themeToShow = checked ? theme : darkTheme;
        setSelectedTheme(themeToShow)
    }
    useEffect(() => {
        (async () => {
                try {
                    setIsLoading(true)
                    await AuthActions.loadUser(dispatch, BACKEND_SERVICE_NAME, meMultiUrl)
                } finally {
                    setIsLoading(false)
                }
            }
        )();
    }, []);

    if (isLoading) {
        return <div style={{margin: "35vh"}}>
            <MainLoader/>
        </div>
    }


    return (
        <>
            <ThemeProvider theme={selectedTheme}>
                <Box sx={styles.root}>
                    <CssBaseline/>
                    {auth?.user && (
                        <Navbar
                            bIsSidebarOpen={bIsSidebarOpen}
                            handleDrawerClose={() => SetSideBarOpenState(false)}
                            handleDrawerOpen={() => SetSideBarOpenState(true)}
                            auth={{isAuthenticated: true}}
                            ui={{nSidebarWidth, nNavbarHeight: 78}}
                            orgsWithPermssions={userOrganizations}
                            location={location.pathname}
                            links={[]}
                            updateCheckedToFather={(checked) => {
                                handleThemeChange(checked);
                            }}
                            title={"Publisher Logins"}
                            logout={{
                                text: "Logout",
                                action: async () => await AuthActions.logout(dispatch, history, logoutUrl),
                                icon: <Logout/>,
                            }}
                            mainGridProps={{justifyContent: "flex-end"}}
                            childrenGridProps={{}}
                        >
                            <PublisherLoginsSelect
                                publisherLogins={publisherLogins}
                                selectedPL={selectedPL}
                                isLoading={isLoading}
                                setSelectedPL={setSelectedPL}
                                setAlert={setAlert}
                            />
                        </Navbar>
                    )}

                    <Box component="main" sx={styles.content}>
                        <Box sx={styles.toolbar}/>
                        <PublisherLoginsContext.Provider value={{publisherLogins, refetchPublisherLogins, isLoadingPL}}>
                            <SelectedPLContext.Provider value={{selectedPL}}>
                                {!isLoadingPL ? (
                                    <Switch>
                                        <Route component={Routes}/>
                                    </Switch>
                                ) : (
                                    <Box sx={{position: 'absolute', top: '35%', left: '35%'}}>
                                        <MainLoader/>
                                    </Box>
                                )}
                            </SelectedPLContext.Provider>
                        </PublisherLoginsContext.Provider>
                    </Box>
                </Box>
                <Footer
                    text={""}
                    logoUrl={""}
                    tagline={""}
                    description={""}
                    hideTags={true}
                    disableCopyrights={true}
                />
            </ThemeProvider>
        </>
    );
};


export default connector(App);
